import type { Subscription } from '../types/subscription';
import SubscriptionTrialStatus from '../constants/subscription-trial-status';

const isActiveTrialSubscription = (subscription: Subscription): boolean =>
  subscription.properties.trial === SubscriptionTrialStatus.STARTED;

export default isActiveTrialSubscription;
